import React from "react";
import "./Vision.css";
import Visioncrad from "./Visioncrad";

function Vision() {
  return (
    <div className="vision-container">
      <div className="vison-content-container">
        <div className="sec-title">Our Vision</div>
        <p className="vision-container-heading">
          Our Vision is to transform career and educational guidance by
          seamlessly integrating AI intelligence with expert human support
          across all stages of personal development.
        </p>
        <div className="vision-cards-container">
          <Visioncrad />
        </div>
        <p className="vision-container-lower">
        Together, we envision a future where technology and empathy unite to
        create smarter, more inclusive pathways for success.
      </p>
      </div>
    </div>
  );
}

export default Vision;
